export default __webpack_public_path__ + "static/media/camera.3ac7f599.svg";